
import {useMutation} from "react-query";
import {useFormik} from "formik";
import {useParams} from "react-router-dom";
import api from "../../services/api";
import queryClient from "../../services/queryClient";

const commentMutation = ({timing, ...data}) => {
    const formData = new FormData();
    formData.append('body', data.body);
    if(data.attachment !== false) {
        formData.append('attachment', data.attachment ? data.attachment : '');
    }

    return api.post(`/timings/${timing}/comments`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    }).then(response => response.data && response.data.data);
};

const useCreateComment = (config = {}) => {
    const { timing } = useParams();

    const mutation = useMutation(commentMutation, {
        ...config,
        onSuccess: (data) => {
            formik.resetForm();

            queryClient.setQueryData([timing, 'comments'], (oldData) => {
                if(oldData?.pages[0]) {
                    oldData.pages.length = 1;
                    oldData.pages[0].data.unshift(data);
                    oldData.pages[0].data.length = Math.min(oldData.pages[0].meta.per_page, oldData.pages[0].data.length);
                }

                return oldData;
            })

            return config?.onSuccess ? config.onSuccess(data) : true;
        },
    });

    const formik = useFormik({
        initialValues: {
            body: '',
            attachment: false,
            timing,
        },
        validate: (values) => {
            mutation.reset();

            const errors = {};

            if(values.body.length <= 5) {
                errors.body = "Your comment needs to be longer than 5 characters!"
            }

            return errors;
        },
        onSubmit: mutation.mutateAsync,
    });

    return {
        formik,
        mutation,
    };
};

export default useCreateComment;
